import ConfirmationDialog from 'components/Common/ConfirmationDialog';
import Grid from '@mui/material/Grid';
import React, { useContext } from 'react';
import {
  Checkbox, FormControlLabel, Typography,
} from '@mui/material';
import { FlowBuilderContext } from './FlowBuilderContextProvider';
import { HButton, HDialogActions, HDialogContent } from 'BaseComponents';


const Content = ({
  cleanRoomFlow, skipConfirmation, onSkipConfirmationChange,
}) => (
  <HDialogContent>
    <Typography
      variant='body2'
      sx={{ whiteSpace: 'pre-line', mb: 1 }}
    >
      {`The current flow version (v${cleanRoomFlow?.flowVersion}) has existing run reports.

        Modifying this version's structure will affect these reports:
        • Removing nodes: Node data will be lost from existing reports

        Save as a new version to preserve your historical reports while implementing your changes.
      `}
    </Typography>
    <FormControlLabel
      control={(
        <Checkbox
          size='small'
          checked={skipConfirmation}
          onChange={(e) => onSkipConfirmationChange(e.target.checked)}
        />
      )}
      slotProps={{
        typography: {
          variant: 'body2',
        },
      }}
      label="Don't ask again this session"
    />
  </HDialogContent>
);

const Actions = ({
  actionsToTrigger, onClose, onSaveNewVersion,
}) => {
  const handleContinue = () => {
    // Trigger all actions queued from react-flow event handlers
    actionsToTrigger.forEach((action) => {
      action.handle({ type: 'continue' });
    });
    onClose();
  };

  const handleSaveAsNewVersion = () => {
    // Trigger all actions queued from react-flow event handlers
    actionsToTrigger.forEach(action => {
      action.handle({ type: 'saveAsNew' });
    });

    onSaveNewVersion();
    onClose();
  };
  return (
    <HDialogActions
      sx={{
        justifyContent: 'initial',
      }}
    >
      <Grid display='flex' justifyContent='flex-start'>
        <HButton variant='text' size='small' onClick={() => onClose()}>
          Cancel
        </HButton>
      </Grid>
      <Grid display='flex' justifyContent='flex-end' columnGap={1} flex={1}>
        <HButton
          variant='outlined'
          size='small'
          onClick={() => handleContinue()}
        >
          Continue
        </HButton>
        <HButton
          variant='contained'
          color='primary'
          size='small'
          onClick={() => handleSaveAsNewVersion()}
        >
          Save as New Version
        </HButton>
      </Grid>
    </HDialogActions>
  );
};

const FlowVersioningPrompt = () => {
  const {
    cleanRoomFlow,
    flowVersioningDialog,
    handleFlowVersioningDialogClose,
    handleUpdateFlowAndCreateNewVersion,
    handleSkipConfirmationChange,
  } = useContext(FlowBuilderContext);

  return (
    <ConfirmationDialog
      open={flowVersioningDialog.open}
      title='Node Changes Will Alter Report Data'
      onCancel={() => handleFlowVersioningDialogClose()}
      slots={{
        content: (
          <Content
            cleanRoomFlow={cleanRoomFlow}
            skipConfirmation={flowVersioningDialog.skipConfirmation}
            onSkipConfirmationChange={handleSkipConfirmationChange}
          />
        ),
        actions: (
          <Actions
            actionsToTrigger={flowVersioningDialog.actions}
            onClose={handleFlowVersioningDialogClose}
            onSaveNewVersion={handleUpdateFlowAndCreateNewVersion}
          />
        ),
      }}
    />
  );
};


export default FlowVersioningPrompt;
